import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Navigation } from 'app/core/navigation/navigation.types';
import { ReplaySubject, tap } from 'rxjs';
import { NavigationPermissionService } from '../services/navigation-permission.service';
import { AuthpermissionsService } from '../auth/authpermissions.service';

@Injectable({ providedIn: 'root' })
export class NavigationService {

    private _httpClient = inject(HttpClient);
    private _permissionService = inject(NavigationPermissionService);
    private _authPermissions = inject(AuthpermissionsService);

    private _navigation = new ReplaySubject<Navigation>(1);
    navigation$ = this._navigation.asObservable();

    private _rawNavigation!: Navigation;

    getRaw() {
        return this._httpClient
            .get<Navigation>('api/common/navigation')
            .pipe(
                tap(nav => {
                    this._rawNavigation = nav;
                    // ✅ NO emitir inmediatamente, esperar permisos
                    // this._navigation.next(nav); ❌ QUITAR ESTO

                    // ✅ Aplicar filtro con los permisos actuales
                    const currentPermissions = this._authPermissions.permissions$.value;
                    this.applyPermissions(currentPermissions);
                })
            );
    }

    constructor() {
        // ✅ QUITAR el filter, permitir arrays vacíos
        this._authPermissions.permissions$
            .subscribe(permisos => {
                // Solo aplicar si ya tenemos la navegación raw cargada
                if (this._rawNavigation) {
                    this.applyPermissions(permisos);
                }
            });
    }

    applyPermissions(permisos: string[]): void {
        // ✅ Si no hay navegación raw, no hacer nada
        if (!this._rawNavigation) {
            return;
        }

        const filtrada: any = {
            default: this._permissionService.filter(
                this._rawNavigation.default,
                permisos
            )
        };

        this._navigation.next(filtrada);
    }
}
